<template>
    <div class="col-md-12">
        <div class="col-md-12">
            <div class="row row-table-title">
                <div class="col-lg-12 col-xs-12 col-md-12 margin-tb dark-green-title">
                    <div class="pull-left">
                        <h3 class="white-font  row-table-font-margins">{{formTitle}} for building: {{ buildingName }}</h3>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-md-12 form-background">
                    <div class="col-xs-12 col-sm-12 col-md-12">
                        <div class="form-group">
                            <strong>Property:</strong>
                            <select class="form-control" v-model="propertyId">
                                <option v-for="property in properties" :value="property.id">{{ property.propertyName }}</option>
                            </select>
                            <div v-if="submitted && !propertyId" class="invalid-feedback d-block">Property is required</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12">
                        <div class="form-group">
                            <strong>Name:</strong>
                            <input type="text" placeholder="Name" class="form-control" v-model="name" />
                            <div v-if="submitted && !name" class="invalid-feedback d-block">Name is required</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12">
                        <div class="form-group">
                            <strong>Phone Number:</strong>
                            <input type="text" placeholder="Phone number" class="form-control" v-model="phoneNumber" />
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12">
                        <div class="form-group">
                            <strong>Email:</strong>
                            <input type="email" placeholder="Email" class="form-control" v-model="email" />
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                        <div class="col-md-2 col-md-offset-4">
                            <button type="submit" @click="saveContact()" class="btn btn-edit btn-full-width">Submit</button>
                        </div>
                        <div class="col-md-2">
                            <button @click="cancel()" class="btn btn-primary btn-full-width">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
    import { redirectToBuildingList } from "@/_helpers/list-redirect";
    export default {
        data: function () {
            return {
                name:'',
                surname:'',
                phoneNumber:'',
                email:'',
                position:1,
                properties:[],
                id:0,
                propertyId:0,
                submitted: false,
                formTitle:'Add new contact',
                buildingId:0,
             //   buildingName:''
            }
        },
        mounted() {
            if (redirectToBuildingList(this, "contacts")) return;
            this.buildingName = this.$route.params.buildingName;
            if(this.$route.params.id)
            {
                this.id = this.$route.params.id;
                this.buildingId = this.$route.params.buildingId;
                this.formTitle = 'Update contact';
                this.getContact();
            }
            else
            {
                this.buildingId = this.$route.params.buildingId;
            }
            this.getProperties();  
		},
        methods: {
            cancel(){
                this.$router.push({name:'contacts',params:{buildingId: this.buildingId}})
            },
            getProperties: function (){
                this.mute = true;
                    //this.buildingId = 3;
                    var request = '/properties/building?id='+this.buildingId;
                    this.$http.get(request, {
                        id : this.buildingId
                    }).then(({data}) => {
                                this.mute = false;
                                //this.contacts = data.contacts;
                            this.properties = data;

                });
            },
            getContact: function(){
                this.$http.get('/contacts/'+this.id).then((response)=>{
                    this.propertyId = response.data.propertyId,
                   // this.buildingName = response.data.building.name,
                    this.name = response.data.name,
                    this.email = response.data.email,
                    this.phoneNumber = response.data.phoneNumber
                });
            },
            saveContact: function(){
                var canSubmit = this.name && this.propertyId 
                if (this.id)
                {
                    this.submitted = true;
                    if(canSubmit)
                        this.$http.put('/contacts/'+this.id, {
                                id: this.id,
                                name: this.name,
                                propertyId: this.propertyId,
                                email:this.email,
                                phoneNumber:this.phoneNumber,
                               // buildingId:this.buildingId
                            
                            }).then(() => {
                            this.$router.push({name:'contacts',params:{buildingId: this.buildingId}})
                            }, () => {
                                alert('error')
                            //  this.infoError = true
                            //  this.loader = false
                            //   this.password = ''
                            })
                }
                else{
                    this.submitted = true;
                    if(canSubmit)
                        this.$http.post('/contacts', {
                                name: this.name,
                                phoneNumber:this.phoneNumber,
                                email:this.email,
                                propertyId: this.propertyId,
                               //  buildingId:this.buildingId
                            
                            }).then(() => {
                            this.$router.push({name:'contacts',params:{buildingId: this.buildingId}})
                            }, (response) => {
                                alert(response)
                            //  this.infoError = true
                            //  this.loader = false
                            //   this.password = ''
                            })
                        }
            },
            
		},
		computed :{
            ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
		}
        // Our Javascript logic
    }
</script>
